import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';

var bnrimg = require('../../images/banner/privacidad.jpg');

const LegalNotice = () => {
    const { t } = useTranslation();
    return (
        <>
            <Header />
            <div className="page-content">
                <Banner title={t('pages.legal.avisoLegal.bannerTitle')} pagename={t('pages.legal.avisoLegal.bannerPagename')} description={t('pages.legal.avisoLegal.bannerDescription')} bgimage={bnrimg} />

                <div className="section-full p-t80 p-b50 mobile-page-padding">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="service-single-block m-b30">
                                    <h3 className="m-b20">{t('pages.legal.avisoLegal.title')}</h3>
                                    <p>{t('pages.legal.avisoLegal.intro')}</p>

                                    <h4>{t('pages.legal.avisoLegal.identification.heading')}</h4>
                                    <p>{t('pages.legal.avisoLegal.identification.body')}</p>
                                    <ul>
                                        <li><strong>{t('pages.legal.avisoLegal.identification.ownerLabel')}</strong> {t('pages.legal.avisoLegal.identification.ownerValue')}</li>
                                        <li><strong>{t('pages.legal.avisoLegal.identification.addressLabel')}</strong> {t('pages.legal.avisoLegal.identification.addressValue')}</li>
                                        <li><strong>{t('pages.legal.avisoLegal.identification.emailLabel')}</strong> customer-service@soltarc.com</li>
                                        <li><strong>{t('pages.legal.avisoLegal.identification.phoneLabel')}</strong> 4424 488 6193</li>
                                    </ul>

                                    {t('pages.legal.avisoLegal.sections', { returnObjects: true }).map((section, index) => (
                                        <React.Fragment key={index}>
                                            <h4>{section.heading}</h4>
                                            <p>{section.body}</p>
                                        </React.Fragment>
                                    ))}

                                    <p><strong>{t('pages.legal.avisoLegal.lastRevisionLabel')}</strong> {t('pages.legal.avisoLegal.lastRevisionValue')}</p>
                                    <p><strong>SoltArc Services</strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default LegalNotice;
